import React from "react";
import moment from "moment";
import {
  Table,
  TableBody,
  TableHeader,
  TableFooter,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from "material-ui/Table";
import { gql, graphql } from "react-apollo";
import { fromJS } from "immutable";

const calculateDailySummary = (orders, product, variation) => {
  const matchProductAndVariation = (product, variation) => line => {
    if (!product) return true;
    if (!variation)
      return line.getIn(["variation", "product", "id"]) === product;
    return (
      line.getIn(["variation", "product", "id"]) === product &&
      line.getIn(["variation", "id"]) === variation
    );
  };
  const b = orders
    .groupBy(o => moment(o.get("createdAt")).startOf("day"))
    .map((dateValue, dateKey) =>
      dateValue
        .map(o =>
          o
            .get("orderLines")
            .filter(matchProductAndVariation(product, variation))
            .map(line => ({
              date: dateKey.format("DD/MM/YYYY"),
              quantity: line.get("quantity"),
              total: line.get("quantity") * line.get("unitPrice")
            }))
        )
        .flatten(1)
        .reduce((a, b) => ({
          date: a.date,
          quantity: a.quantity + b.quantity,
          total: a.total + b.total
        }))
    )
    .filter(date => !!date); //we filter out empty dates

  return b.toArray();
};

export const DailyReportTable = ({ data, product, variation }) => {
  const orders = fromJS(data.orders);
  if (!orders) return null;
  const summary = calculateDailySummary(orders, product, variation);
  // console.log('SUMMARY', summary)
  if (Object.keys(summary).length === 0) return <div />;

  const rows = summary.map(row =>
    <TableRow key={row.date}>
      <TableRowColumn>
        {row.date}
      </TableRowColumn>
      <TableRowColumn>
        {row.quantity}
      </TableRowColumn>
      <TableRowColumn>
        {row.total}€
      </TableRowColumn>
    </TableRow>
  );

  const total = summary.reduce((a, b) => ({
    date: a.date,
    quantity: a.quantity + b.quantity,
    total: a.total + b.total
  }));

  return (
    <Table selectable={false}>
      <TableHeader displaySelectAll={false}>
        <TableRow>
          <TableHeaderColumn>Día</TableHeaderColumn>
          <TableHeaderColumn>Nº items</TableHeaderColumn>
          <TableHeaderColumn>Ingresos</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody displayRowCheckbox={false} showRowHover={true}>
        {rows}
      </TableBody>
      <TableFooter>
        <TableRow>
          <TableHeaderColumn>TOTAL</TableHeaderColumn>
          <TableHeaderColumn>
            {total.quantity}
          </TableHeaderColumn>
          <TableHeaderColumn>
            {total.total}€
          </TableHeaderColumn>
        </TableRow>
      </TableFooter>
    </Table>
  );
};

const Orders = gql`
  query Orders {
    orders {
      id
      paid
      delivered
      createdAt
      updatedAt
      orderLines {
        id
        quantity
        unitPrice
        createdAt
        updatedAt
        statusAt
        variation {
          id
          name
          product {
            id
            name
          }
        }
      }
    }
  }
`;

export default graphql(Orders)(DailyReportTable);



// WEBPACK FOOTER //
// ./src/components/presentational/DailyReportTable.js